module.exports = __webpack_public_path__ + "img/sideicon1.65176f71.png";